var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListNoteJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 0.623779H3.7915V1.70711H12.9998V0.623779Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 0.623779H3.7915V1.70711H12.9998V0.623779Z",
    fill: "#797D8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7915 0.623779V-20.7096H-17.5418V0.623779H3.7915ZM12.9998 0.623779H34.3332V-20.7096H12.9998V0.623779ZM12.9998 1.70711V23.0404H34.3332V1.70711H12.9998ZM3.7915 1.70711H-17.5418V23.0404H3.7915V1.70711ZM3.7915 21.9571H12.9998V-20.7096H3.7915V21.9571ZM-8.3335 0.623779V1.70711H34.3332V0.623779H-8.3335ZM12.9998 -19.6262H3.7915V23.0404H12.9998V-19.6262ZM25.1248 1.70711V0.623779H-17.5418V1.70711H25.1248Z",
    fill: "#797D8A",
    mask: "url(#path-1-inside-1_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 4.41528H3.7915V5.49862H12.9998V4.41528Z",
    fill: "#797D8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 8.20703H3.7915V9.29037H12.9998V8.20703Z",
    fill: "#797D8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08333 2.24869C1.68164 2.24869 2.16667 1.76367 2.16667 1.16536C2.16667 0.567055 1.68164 0.0820312 1.08333 0.0820312C0.485025 0.0820312 0 0.567055 0 1.16536C0 1.76367 0.485025 2.24869 1.08333 2.24869Z",
    fill: "#797D8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08333 6.04044C1.68164 6.04044 2.16667 5.55542 2.16667 4.95711C2.16667 4.3588 1.68164 3.87378 1.08333 3.87378C0.485025 3.87378 0 4.3588 0 4.95711C0 5.55542 0.485025 6.04044 1.08333 6.04044Z",
    fill: "#797D8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08333 9.83195C1.68164 9.83195 2.16667 9.34692 2.16667 8.74861C2.16667 8.15031 1.68164 7.66528 1.08333 7.66528C0.485025 7.66528 0 8.15031 0 8.74861C0 9.34692 0.485025 9.83195 1.08333 9.83195Z",
    fill: "#797D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNoteJob);
export default __webpack_public_path__ + "static/media/list-note-job.11aba07f7084b1f6f50b95e55ac196c1.svg";
export { ForwardRef as ReactComponent };